import { defineComponent as _defineComponent } from 'vue';
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useInvoiceListStore } from "@js/vue/domain/invoice/stores/useInvoiceListStore";
import { useUserStore } from '@js/vue/domain/user/stores/useUserStore';
import Combobox from "../../../../components/ui/Combobox.vue";
import { Filter, RotateCcw, Calendar, SlidersHorizontal } from 'lucide-vue-next';
export default /*@__PURE__*/ _defineComponent({
    __name: 'InvoiceFilters',
    setup(__props, { expose: __expose }) {
        __expose();
        const invoiceListStore = useInvoiceListStore();
        const { filters, brandOptions, clientManagerOptions, isLoading } = storeToRefs(invoiceListStore);
        const { resetFilters, applyFilters, fetchClientManagerOptions, fetchBrandOptions } = invoiceListStore;
        const userStore = useUserStore();
        const statusOptions = ['open', 'paid', 'overdue'];
        const agingBucketOptions = [
            { label: '30+ Days', value: '30+' },
            { label: '60+ Days', value: '60+' },
            { label: '90+ Days', value: '90+' },
            { label: '120+ Days', value: '120+' },
            { label: '365+ Days (1yr)', value: '365+' },
        ];
        function toggleStatus(status) {
            const currentStatuses = filters.value.statuses ?? [];
            filters.value.statuses = currentStatuses.includes(status)
                ? currentStatuses.filter(s => s !== status)
                : [...currentStatuses, status];
        }
        onMounted(() => {
            if (userStore.canSeeAllBrands) {
                fetchClientManagerOptions();
                fetchBrandOptions();
            }
        });
        const __returned__ = { invoiceListStore, filters, brandOptions, clientManagerOptions, isLoading, resetFilters, applyFilters, fetchClientManagerOptions, fetchBrandOptions, userStore, statusOptions, agingBucketOptions, toggleStatus, Combobox, get Filter() { return Filter; }, get RotateCcw() { return RotateCcw; }, get Calendar() { return Calendar; }, get SlidersHorizontal() { return SlidersHorizontal; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
